/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import { Button } from '@/components/ui/button'
import { Form, FormControl, FormField, FormItem } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { UseFormHandleSubmit, UseFormReturn } from 'react-hook-form'
import { z } from 'zod'
import { formSchema } from '../link-search-form-drawer'
import { cx } from 'class-variance-authority'

interface Props {
  form: UseFormReturn<
    {
      url: string
    },
    any,
    {
      url: string
    }
  >
  handleSubmit: ReturnType<
    UseFormHandleSubmit<(values: z.infer<typeof formSchema>) => void>
  >
  errorMessage?: string
  disabled?: boolean
}

function LinkSearchForm({ errorMessage, disabled, handleSubmit, form }: Props) {
  return (
    <Form {...form}>
      <form onSubmit={handleSubmit}>
        <FormField
          control={form.control}
          name="url"
          render={({ field }) => (
            <>
              <div className="flex gap-[5px]">
                <FormItem className="relative h-[40px] w-full">
                  <FormControl>
                    <Input
                      {...field}
                      className={cx(
                        'rounded-lg border-none bg-gray-1 px-3 py-[13px] pr-9 !text-withdraw-warn placeholder:text-gray-5 focus:border-none focus-visible:ring-1 focus-visible:ring-offset-0',
                        !!errorMessage &&
                          'border-[2.5px] border-solid border-point-red',
                      )}
                      placeholder="찾으시는 상품이 있으신가요?"
                      disabled={disabled}
                    />
                  </FormControl>
                  <Button
                    type="button"
                    variant="ghost"
                    className="absolute bottom-1/2 right-3 size-4 translate-y-1/2 p-px"
                    onClick={() => {
                      form.setValue('url', '')
                      form.setFocus('url')
                    }}
                  >
                    <XIcon />
                  </Button>
                  {disabled && (
                    <div className="absolute top-0 !mt-0 h-[40px] w-full rounded-lg bg-gray-3 opacity-40"></div>
                  )}
                </FormItem>
                <Button variant="primary" disabled={disabled}>
                  검색
                </Button>
              </div>
              {errorMessage && (
                <div className="mt-2 pl-2 text-caption-01-medium text-point-red">
                  {errorMessage}
                </div>
              )}
            </>
          )}
        />
      </form>
    </Form>
  )
}

function XIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        fill="#C9C9C9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64262 10.354C5.44735 10.1588 5.44735 9.8422 5.64262 9.64693L9.64309 5.64647C9.83835 5.4512 10.1549 5.4512 10.3502 5.64647C10.5455 5.84173 10.5455 6.15831 10.3502 6.35357L6.34972 10.354C6.15446 10.5493 5.83788 10.5493 5.64262 10.354Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64645 5.64603C5.84171 5.45077 6.15829 5.45077 6.35355 5.64603L10.354 9.6465C10.5493 9.84177 10.5493 10.1583 10.354 10.3536C10.1588 10.5489 9.84218 10.5489 9.64692 10.3536L5.64645 6.35314C5.45118 6.15788 5.45118 5.8413 5.64645 5.64603Z"
        fill="white"
      />
    </svg>
  )
}

export default LinkSearchForm
